// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/colors.css
// module id = 33
// module chunks = 0